import { useEffect, useState } from "react";
import "../css/ScheduleBox.css";

const ScheduleBox = ({ teamName }) => {
  const [list, setList] = useState([]);

  useEffect(() => {
    if (!teamName) {
      setList([]);
      return;
    }
    const url = `${process.env.REACT_APP_API_URL}/api/soccer/team/${encodeURIComponent(teamName)}/upcoming`;
    //const url = `http://localhost:5001/api/soccer/team/${encodeURIComponent(teamName)}/upcoming`;

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        // soonest first
        const sorted = [...data].sort((a, b) => new Date(a.utcDate) - new Date(b.utcDate));
        setList(sorted);
      })
      .catch((err) => {
        console.log("schedule error:", err);
        setList([]);
      });
  }, [teamName]);

  return (
    <div className="schedule-box">
      <div className="schedule-header">
        <span>Date</span>
        <span>Match</span>
        <span className="time-col">Time</span>
      </div>

      <div className="schedule-list">
        {list.length === 0 ? (
          <p className="schedule-empty">Loading upcoming matches.</p>
        ) : (
          list.map((match, index) => (
            <div key={index} className="schedule-row">
              <span className="date-col">
                {new Date(match.utcDate).toLocaleDateString()}
              </span>

              <span className="match-col">
                {match.homeTeam} vs {match.awayTeam}
              </span>

              <span className="time-col">
                {new Date(match.utcDate).toLocaleTimeString([], {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default ScheduleBox;